import { Component, OnInit, Output,Input ,EventEmitter  } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import Swal from "sweetalert2";
import { MessagesTitles, MessagesStatus } from '../../../../models/messages'; 
import { LoginService } from 'app/services/login/login.service';
import { EmpresasService } from '../../../../services/empresas/empresas.service'; 
import { RiesgoService } from '../../../../services/riesgo/riesgo.service'; 
import { environment } from 'environments/environment';
import { DatePipe } from "@angular/common";
@Component({
  selector: 'app-nuevo-corte',
  templateUrl: './nuevo-corte.component.html',
  styleUrls: ['./nuevo-corte.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})
export class NuevoCorteComponent implements OnInit {
  
  
  @Output() cerrarAgregarCorte: EventEmitter<boolean>;
  @Output() refresh = new EventEmitter<boolean>();

  loading: boolean = false; 

  user: any;
  Titulo: string;
  editar: boolean;

  formularioContacto: FormGroup;
 

  constructor(
    private riesgoService : RiesgoService ,  
     private routerActive:ActivatedRoute,
     private msgTitulos : MessagesTitles,
     private msgStatus:MessagesStatus,
     private loginService:LoginService,
     private datePipe:DatePipe) {

    this.cerrarAgregarCorte = new EventEmitter();
    this.loginService.clickGuard = true;
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.Titulo = "Nuevo registro";
   
    

    this.formularioContacto = new FormGroup({
      "CantidadFacturas": new FormControl('',  Validators.required),
      "CantidadRetiros":new FormControl('',  Validators.required),  
      "CantidadReprogramadas":new FormControl('',  Validators.required),   
      "FechaCorte":new FormControl('',  Validators.required),
      "Usuario": new FormControl(this.user.Usuario)
    });
  }

  ngOnInit() {

  }

 
  crearContacto(){
    this.loading = true;
    if(this.formularioContacto.valid){
      return false;
    }
    this.formularioContacto.controls["FechaCorte"].setValue(
      this.datePipe.transform(
        this.formularioContacto.controls["FechaCorte"].value,
        "yyyy-MM-dd"
      )
    );
      this.riesgoService.agregarProcesoCorte(this.formularioContacto.getRawValue()).subscribe(
        res => {
          this.loading = false;
          Swal.fire({
            title: "¡Éxito!",
            text: 'Proceso registrado correctamente.',
            type: "success",
            allowOutsideClick: false,
            heightAuto: false
          }).then( respu => {
            if (respu.value == true){
              this.loginService.clickGuard = true;
              this.refresh.emit();
              this.cerrarAgregarCorte.emit();
            }
          });
      },(err: HttpErrorResponse)=> {
        this.loading=false;
        this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "Proceso no registrado. "+this.msgStatus.message,
          type: "error",
          footer:"<span>"+err.error.error+"</span>",
          allowOutsideClick: true,
          heightAuto: false
        })
      })
        
  }


  
  CerrarPopUp(){
    this.cerrarAgregarCorte.emit();
  }
}
